import { Phases } from "./phases";

type Phase = typeof Phases[keyof typeof Phases];

interface RestrictROITemplateParams {
  templateToRestrict: Phase;
  roi: boolean;
}

const restrictROITemplate = ({
  templateToRestrict,
  roi
}: RestrictROITemplateParams): Phase => {
  return templateToRestrict !== Phases.ROI || roi
    ? templateToRestrict
    : Phases.VALUE_HYPOTHESIS;
};

export default restrictROITemplate;
